import React from 'react';
import { useContact } from '../../hooks/useContact';
import PhoneNumber from '../../components/text/PhoneNumber/PhoneNumber';
import { addressTypeRenderer, legalRenderer } from '../../components/templates/LegalSidebar/LegalSidebar';
import Spacer from '../../components/structure/Spacer/Spacer';

// TODO translate...
import { jsx as ___EmotionJSX } from "@emotion/react";
const ContactInfo = () => {
  const {
    company_name,
    phoneNumber,
    email,
    address,
    executives,
    legal_form
  } = useContact();
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", {
    style: {
      marginBottom: 0
    }
  }, company_name), address.address_type && ___EmotionJSX("i", null, addressTypeRenderer(address.address_type)), ___EmotionJSX(Spacer, {
    height: 10
  }), ___EmotionJSX("b", null, legalRenderer(legal_form)), executives.map(_ref => {
    let {
      name
    } = _ref;
    return ___EmotionJSX("p", {
      style: {
        marginBottom: 0
      },
      key: name
    }, name);
  }), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("p", null, address.street, " ", address.number, " ", ___EmotionJSX("br", null), " ", address.zip_code, " ", address.city), ___EmotionJSX("p", null, "Telefon: ", ___EmotionJSX(PhoneNumber, {
    number: phoneNumber.number,
    callable: false
  })), ___EmotionJSX("p", null, "E-Mail: ", email.email));
};
export default ContactInfo;